/* RESPONSIBLE TEAM: team-automation-foundations */

import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class DatasetExportScheduleSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    deliveryAt: { serialize: false },
  };
}
